import {createReducer, getType} from "typesafe-actions"

// Models
import {AuthStateType} from "../../models"

// Actions
import * as a from "../actions"

const InitialAuthState: AuthStateType = {
    user: null,
    signingIn: false,
    authorizing: true,
    signInError: null,
};

const authReducer = createReducer<AuthStateType>(InitialAuthState, {
    [getType(a.signInAsync.request)]: state => ({
        ...state,
        signingIn: true,
        signInError: null,
    }),
    [getType(a.signInAsync.failure)]: (state, {payload: signInError}) => ({
        ...state,
        signInError,
        signingIn: false,
    }),
    [getType(a.signInAsync.success)]: (state, {payload: user}) => ({
        ...state,
        user,
        signingIn: false,
    }),
    [getType(a.fetchCurrentUserAsync.success)]: (state, {payload: user}) => ({
        ...state,
        user,
        authorizing: false,
    }),
    [getType(a.fetchCurrentUserAsync.failure)]: state => ({
        ...state,
        authorizing: false,
    }),
    [getType(a.signOutAsync.success)]: () => ({
        ...InitialAuthState,
        authorizing: false,
    }),
});

export default authReducer
